// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimConditionModel {
    static getAttributeTypeMap() {
        return ClaimConditionModel.attributeTypeMap;
    }
}
ClaimConditionModel.discriminator = undefined;
ClaimConditionModel.additionalProperties = false;
ClaimConditionModel.attributeTypeMap = [
    {
        "name": "conditionTypeId",
        "baseName": "conditionTypeId",
        "type": "number"
    },
    {
        "name": "conditionStatusId",
        "baseName": "conditionStatusId",
        "type": "number"
    },
    {
        "name": "conditionStatusCategoryId",
        "baseName": "conditionStatusCategoryId",
        "type": "number"
    },
    {
        "name": "isCompleted",
        "baseName": "isCompleted",
        "type": "boolean"
    },
];
//# sourceMappingURL=claimConditionModel.js.map